<div class="app-shell">
  <nav class="sidenav" [class.collapsed]="collapsed()">

    <!-- Floating toggle FAB -->
    <button class="nav-toggle-fab" (click)="toggleNav()"
            [matTooltip]="collapsed() ? 'Expand' : 'Collapse'" matTooltipPosition="right">
      <mat-icon>{{ collapsed() ? 'chevron_right' : 'chevron_left' }}</mat-icon>
    </button>

    <div class="sidenav-inner">

      <!-- Header -->
      <div class="nav-header">
        <div class="logo-mark">
          <img src="icons/chubb-ai-logo.svg" alt="Chubb AI" class="logo-svg" />
        </div>
        <div class="nav-title">
          <span class="nav-title-brand">Consumer+</span>
          <span class="nav-title-sub">Studio</span>
        </div>
      </div>

      <!-- Main nav -->
      <div class="nav-section">
        @if (!collapsed()) {
          <span class="section-label">MAIN</span>
        }
        <mat-nav-list>
          <a mat-list-item routerLink="/agents" routerLinkActive="active-link"
             [routerLinkActiveOptions]="{ exact: false }"
             [matTooltip]="collapsed() ? 'Agent Studio' : ''" matTooltipPosition="right">
            <span class="nav-item-inner">
              <mat-icon>smart_toy</mat-icon>
              @if (!collapsed()) { <span class="nav-label">Agent Studio</span> }
            </span>
          </a>
          <a mat-list-item routerLink="/knowledge-base" routerLinkActive="active-link"
             [routerLinkActiveOptions]="{ exact: false }"
             [matTooltip]="collapsed() ? 'Knowledge Base' : ''" matTooltipPosition="right">
            <span class="nav-item-inner">
              <mat-icon>menu_book</mat-icon>
              @if (!collapsed()) { <span class="nav-label">Knowledge Base</span> }
            </span>
          </a>
          <a mat-list-item routerLink="/tests" routerLinkActive="active-link"
             [routerLinkActiveOptions]="{ exact: false }"
             [matTooltip]="collapsed() ? 'Tests' : ''" matTooltipPosition="right">
            <span class="nav-item-inner">
              <mat-icon>science</mat-icon>
              @if (!collapsed()) { <span class="nav-label">Tests</span> }
            </span>
          </a>
          <!-- Marketing Studio tab hidden temporarily -->
          <!-- <a mat-list-item routerLink="/content" routerLinkActive="active-link"
             [matTooltip]="collapsed() ? 'Marketing Studio' : ''" matTooltipPosition="right">
            <span class="nav-item-inner">
              <mat-icon>auto_stories</mat-icon>
              @if (!collapsed()) { <span class="nav-label">Marketing Studio</span> }
            </span>
          </a> -->
        </mat-nav-list>
      </div>

      <div class="nav-spacer"></div>

      <div class="nav-user" matRipple [matMenuTriggerFor]="userMenu">
        @let user = authService.userInfo$ | async;
        <div class="user-avatar">
          @if (user?.photoUrl) {
            <img [src]="user!.photoUrl" alt="Profile" class="user-photo" />
          } @else {
            <mat-icon>account_circle</mat-icon>
          }
        </div>
        @if (!collapsed()) {
          <div class="user-info">
            <span class="user-name">{{ user?.name || 'Studio User' }}</span>
            <span class="user-role">{{ user?.email || 'Consumer+ Studio' }}</span>
          </div>
        }
      </div>
      <mat-menu #userMenu="matMenu">
        <button mat-menu-item (click)="authService.logout()">
          <mat-icon>logout</mat-icon>
          <span>Sign out</span>
        </button>
      </mat-menu>

    </div><!-- /sidenav-inner -->

  </nav>

  <main class="main-content">
    <router-outlet></router-outlet>
  </main>
</div>
